import { computed, defineComponent, watch, onUnmounted } from '@vue/composition-api';
import { OrderStateType, usePaymentBookingPollQuery } from '@/generated-types/graphql.types';
export default defineComponent({
    props: {
        booking: {
            type: Object,
            default: null
        },
        value: {
            type: String,
            default: null
        }
    },
    setup(props, context) {
        const { emit } = context;
        const user = computed(() => globalThis.$store.getters['$_app/user']);
        // Polled every ten seconds, which is exactly what the subscription did:
        // its body was `while True: … yield … await sleep(10)`, never an event
        // stream. Same values, same moments, no websocket.
        const { result, stop } = usePaymentBookingPollQuery(() => ({
            bookingId: props.booking.booking_id,
            accountId: user.value?.account_id
        }), () => ({
            enabled: Boolean(props.booking.booking_id && user.value?.account_id),
            pollInterval: 10000,
            fetchPolicy: 'no-cache'
        }));
        const status = computed(() => {
            emit('input', result?.value?.booking_status?.order.order_state);
            return result?.value?.booking_status?.order.order_state;
        });
        watch(result, (bookingCurr, bookingPrev) => {
            if (bookingCurr?.booking_status?.booking_status &&
                bookingCurr?.booking_status?.booking_status !==
                    bookingPrev?.booking_status?.booking_status) {
                emit('onStatusChanged');
            }
        }, { immediate: true });
        onUnmounted(() => {
            stop();
        });
        return {
            status,
            OrderStateType
        };
    }
});
